<template>
  <div id="app" class="dark:bg-slate-900 w-full">
    <div class="new-status w-full">
      <div class="dark:bg-slate-900 status">
        <div class="payment-heading">Payment History</div>
        <!-- <button @click="showForm = true" class="add_status cursor-pointer">
              Add Status
            </button> -->
      </div>
      <div v-if="uiFlags.isFetching" class="no-states">
        <loading-state
          v-if="uiFlags.isFetching"
          :message="emptyStatusMessage"
        />
      </div>
     <div
  v-if="paymentsData.payments.length === 0"
  class="no-data-screen"
>
  <p class="no-data-text">No Data Available</p>
</div>
      <div v-else class="table-container w-[calc(100vw-20px)]">
        <div class="w-full h-full">
          <div v-if="paymentsData.payments.length === 0" class="min-h-[80vh] flex justify-center items-center">
          <p class="text-center font-semibold text-[30px]">No Data Available</p>
          </div>
          <table v-else
            border="1"
            class="min-w-full h-full text-sm text-left text-slate-500 dark:text-slate-400"
          >
            <thead
              class="table-row-heading bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300"
            >
              <tr>
                <th class="px-4 py-2">S.No.</th>
                <th class="px-4 py-2">Agent</th>
                <th class="px-4 py-2">Status</th>
                <th class="px-4 py-2">Date</th>
                <th class="px-4 py-2">GST</th>
                <th class="px-4 py-2">Payment Type</th>
                <th class="px-4 py-2">Amount</th>
              </tr>
            </thead>
            <tbody>
              <!-- <tr v-if="paymentsData.payments.length === 0">
                <td
                  colspan="7"
                  class="text-center font-semibold text-[30px] py-4"
                >
                  No Data Available
                </td>
              </tr> -->
              <tr
                v-for="(status, index) in paymentsData.payments"
                :key="status.id"
                class="border-gray-200 border-t dark:bg-slate-900 dark:hover:bg-slate-700 hover:bg-gray-50"
                :class="{ 'bg-slate-100 dark:bg-slate-700': index % 2 !== 0 }"
              >
                <td class="px-4 py-2">{{ index + 1 }}</td>
                <td class="px-4 py-2 break-all">
                  {{ status.agent?.name || 'NA' }}
                </td>
                <td class="px-4 py-2 break-all">{{ status.name || 'NA' }}</td>
                <td class="px-4 py-2 break-all">
                  {{ formatDate(status.created_at) || 'NA' }}
                </td>
                <td class="px-4 py-2 break-all">{{ status.gst_no || 'NA' }}</td>
                <td class="px-4 py-2 break-all">
                  {{ status.payment_type || 'NA' }}
                </td>
                <td
                  class="px-4 py-2 break-all text-right text-green-600 dark:text-green-400 font-medium"
                >
                  ₹{{ status.amount || 'NA' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="showErrorDiv" class="error-div">
        <button class="close-icon" @click="closeErrorDiv">✖</button>
        {{ errorMessage }}
      </div>
    </div>

    <!-- <div v-if="totalPages > 1" class="pagination">
      <button @click="changePage(1)" :disabled="currentPage === 1">
        First
      </button>
      <button
        @click="changePage(currentPage - 1)"
        :disabled="currentPage === 1"
      >
        Previous
      </button>
      <span v-for="page in totalPages" :key="page">
        <button
          @click="changePage(page)"
          :class="{ active: page === currentPage }"
        >
          {{ page }}
        </button>
      </span>
      <button
        @click="changePage(currentPage + 1)"
        :disabled="currentPage === totalPages"
      >
        Next
      </button>
      <button
        @click="changePage(totalPages)"
        :disabled="currentPage === totalPages"
      >
        Last
      </button>
    </div> -->
    <loading-state v-if="uiFlags.isFetching" :message="emptyStateMessage"  class="loadingScreeen"/>
    <table-footer
    v-else
      :current-page="Number(currentPageNumber(this.$route.query.page) || 1)"
      :total-count="paymentsData.meta.total_count"
      :page-size="15"
      @page-change="onPageChange"
    />
  </div>
</template>
<script>
import axios from 'axios';
import alertMixin from 'shared/mixins/alertMixin';
import formatDateMixin from 'dashboard/mixins/formatDateMixin';
import { mapGetters } from 'vuex';
import { getRandomColor } from 'dashboard/helper/labelColor';
import Editor from 'dashboard/components/widgets/WootWriter/Editor.vue';
import LoadingState from 'dashboard/components/widgets/LoadingState';
import TableFooter from 'dashboard/components/widgets/TableFooter.vue';

const DEFAULT_PAGE = 1;


export default {
  components: {
    Editor,
    LoadingState,
    TableFooter,
  },
  data() {
    return {
      selectedColor: '',
      selectedBoard: null,
      originalStatus: null,
      showDeleteModal: false,
      showForm: false,
      editMode: false,
      totalData: '',
      newStatus: {
        id: null,
        name: '',
        description: '',
        index: this.statuses,
        board_id: '',
      },
      // colors: [
      //   '#34922D',
      //   '#FFCC00',
      //   '#2D6FF5',
      //   '#B700AB',
      //   '#D62222',
      //   '#D9488C',
      //   '#FF7700',
      //   '#40518A',
      //   '#4300B7',
      //   '#009EB7',
      // ],
      color: '#EFF3FF',
      colors: [
        '#EFF3FF',
        '#FFF2CC',
        '#DAF8D3',
        '#FDE8E9',
        '#ffa3a3',
        '#ffc3df',
        '#ffc18c',
        '#a7bbff',
        '#ceb2ff',
        '#a7f3ff',
      ],
      statuses: [],
      currentPage: 1,
      perPage: 10, // Number of items per page
      isDeleting: false,
      isCreating: false,
      isUpdating: false,
      isLoading: false,
      showErrorDiv: false,
      errorMessage: '',
      emptyStatusMessage: 'Loading payments', // Default selected color
    };
  },
  mixins: [alertMixin, formatDateMixin],
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      baseUrl: 'getBaseUrl',
      currentUser: 'getCurrentUser',
      uiFlags: 'payments/getUIFlags',
    }),
    paginatedStatuses() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.statuses.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.statuses.length / this.perPage);
    },
  
    paymentsData() {
      this.totalData = this.$store.getters['payments/getPayments'];
      return this.totalData;
    },
  },
  mounted() {
   
    // this.filterData(this.$route.query.page);
  },
  watch: {
  '$route': {
    handler(to) {
      const url = new URL(window.location.href);
      let pageParam = url.searchParams.get('page');
      if (!pageParam || isNaN(Number(pageParam)) || Number(pageParam) < 1) {
        const defaultPage = DEFAULT_PAGE || 1;
        this.$router.replace({
          path: to.path,
          query: {
            ...to.query,
            page: defaultPage
          }
        });
        return;
      }
      if (Object.keys(to.query).length > 1 || !('page' in to.query)) {
        this.$router.replace({
          path: to.path,
          query: { page: pageParam }
        });

        return;
      }
      const selectedPageNumber = Number(pageParam);
      this.filterData(selectedPageNumber);
    },
    immediate: true
  }
},
  methods: {
    currentPageNumber() {
      console.log('this is the page number', this.$route.query.page);
      return this.$route.query.page;
    },
    onPageChange(page) {
      console.log('this is the page data ', page);
      this.updatePageParam(page);
      this.$router.push({
        path: this.$route.path, // Keep the current path
        query: { ...this.$route.query, page: page }, // Keep all other queries, update page
      });
      this.filterData(page);
    },
    updatePageParam(page) {
      window.history.pushState({}, null, `${this.$route.path}?page=${page}`);
      // console.log("Current URL:", window.location.href);
    },
 
    closeOnOutsideClick(event) {
      // Close the modal if clicked outside .modal-content
      if (event.target.classList.contains('modal')) {
        this.closeForm();
        this.closeDeleteModal();
      }
    },
  
    closeErrorDiv() {
      this.showErrorDiv = false;
      this.errorMessage = '';
    },

    closeForm() {
      this.showForm = false;
      this.resetForm();
    },



    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
 
    async filterData(pages = 1) {
      // const currentPage = this.currentPageNumber(this.$route.query.page);
      // console.log("this is so -=-=-=-=-=-", this.totalData.meta);
      // const isValidPage = pages > 0 && pages <= Math.ceil(this.totalData?.meta?.total_count / 15);
      // console.log('Filter Data called with page:', pages);
      // console.log("this is the valid count page number -===-=-0-=-=-=-", isValidPage);
      // if(!isValidPage) {
      //   console.error('Invalid page number:', pages);
      //  pages = 1;
      //  this.updatePageParam(pages);
      //   this.$router.push({
      //     path: this.$route.path,
      //     query: { ...this.$route.query, page: pages},
      //   });
      // }
      const payload = {
        key: 'page',
        value: pages,
      };
      console.log('My Data', payload);
      await this.$store.dispatch('payments/PaymentFilter', payload);
    },
  },
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
.add_status {
  background-color: #40518a;
  color: whitesmoke;
  padding: 8px;
  border-radius: 8px;
}
.status_list {
  font-weight: bold;
}
.status {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}
th,
td {
  padding: 10px;
  text-align: center;
}
th {
  /* background-color: #f2f2f2; */
}
td {
  text-align: center;
}
.buttons {
  font-size: 10px;
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 99;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}
.modal-content {
  padding: 20px;
  border: 1px solid #888;
  width: 40%;
  border-radius: 18px;
  position: relative;
}
.edit-lead {
  margin-right: 5px;
}
.close {
  color: #aaa;
  position: absolute;
  top: 5px;
  right: 15px;
  font-size: 28px;
  font-weight: bold;
}
.no-statuses {
  text-align: center;
}
.no-statuses p {
  font-size: 26px;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.pagination {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.pagination button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px;
  margin: 0 5px;
  cursor: pointer;
  border-radius: 4px;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination button.active {
  font-weight: bold;
}
.heading {
  font-size: 20px;
  font-weight: 600;
}
.editor-ui {
  border: 2px solid lightgrey;
  height: 200px;
  padding-left: 10px;
}
.modal-content {
  max-width: 520px;
}

.modal-content .heading {
  margin-bottom: 20px;
}
.add_board1 {
  /* background-color: #40518a; */
  color: whitesmoke;
  padding: 8px;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}
.add_board1:hover {
  background-color: #283659 !important;
}

.add_board1.no-button {
  color: #1f93ff;
  font-size: 14px;
  padding: 8px 12px;
}

.add_board1.no-button:hover {
  background-color: #ddecf9 !important;
}

.add_board1.yes-button {
  background-color: #feecee !important;
  color: #cd2b31;
  font-size: 14px;
  padding: 8px 12px;
}

.add_board1.yes-button:hover {
  background-color: #f9c6cb !important;
}
.error-div {
  width: 340px;
  height: 70px;
  background-color: #ff0000;
  color: white;
  padding: 10px;
  position: absolute;
  top: 33px;
  right: 37%;
  border-radius: 4px;
}
.close-icon {
  position: absolute;
  top: 6px;
  right: 8px;
  cursor: pointer;
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  padding: 0;
  line-height: 1;
  transition: color 0.3s ease;
}
.table-container {
  /* max-height: 542px; */
  max-height: calc(100vh - 106px);
  overflow-y: auto;
}
.table-row-heading {
  position: sticky;
  top: 0;
  z-index: 1;
  border: none !important;
}
html,
body {
  height: 100%;
  margin: 0;
}
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.new-status {
  width: 100%;
  height: 100%;
}
.payment-heading {
  font-weight: 600;
  font-size: x-large;
}
.loadingScreeen{
  position: absolute;
  z-index: 30;
  background-color: #443f3f6e;
  inset: 0;
  display: grid;
  place-items: center;
  font-size: 30px;
  color: white;
}

.no-data-screen {
  min-height: calc(100vh - 100px);
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9fafb;
}

.dark .no-data-screen {
  background-color: #0f172a;
}

.no-data-text {
  font-size: 30px;
  font-weight: 600;
  color: #64748b;
  text-align: center;
}

.dark .no-data-text {
  color: #cbd5e1;
}

</style>